export default __webpack_public_path__ + "static/media/memMeansMore.10d8db0a.jpg";